
import React from "react";
import classes from "./Chart.module.css";
import { Line } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LineElement,
  LinearScale,
  PointElement,
  Filler,
  Tooltip,
  Title,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LineElement,
  LinearScale,
  PointElement,
  Legend,
  Title,
  Filler,
  Tooltip
);

const Chart = (props) => {
  const chartData = props.data;

  const labels =
    chartData.length !== 0 ? chartData.map((item) => item.stage) : [];

  const Y_labels =
    chartData.length !== 0
      ? chartData.map((item) => {
          const firstDay = chartData[0].date;
          const date2 = new Date(item.date);
          const date1 = new Date(firstDay);

          const Difference_In_Time = date2.getTime() - date1.getTime();
          const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
          return Difference_In_Days;
        })
      : [];

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Customer Journey Details",
      },
      datalabels: {
        display: false, 
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "Details",
        data: Y_labels,
        fill: true,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        pointBorderColor: "Black",
      },
    ],
  };

  return (
    <div className={classes.chart}>
      <Line data={data} options={options} />
    </div>
  );
};

export default Chart;
